import * as React from 'react';

import * as PopoverPrimitive from '@radix-ui/react-popover';

import { cn } from '../lib/utils';

const Popover = PopoverPrimitive.Root;

const PopoverTrigger = PopoverPrimitive.Trigger;

const PopoverPortal = PopoverPrimitive.Portal;

const PopoverContent = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(({ className, align = 'center', sideOffset = 4, ...props }, ref) => (
  // <PopoverPrimitive.Portal>
  <PopoverPrimitive.Content
    ref={ref}
    align={align}
    sideOffset={sideOffset}
    className={cn(
      'vai-z-50 [&&:]vai-w-72 vai-rounded-md vai-border vai-bg-popover vai-p-4 vai-text-popover-foreground vai-shadow-md vai-outline-none data-[state=open]:vai-animate-in data-[state=closed]:vai-animate-out data-[state=closed]:vai-fade-out-0 data-[state=open]:vai-fade-in-0 data-[state=closed]:vai-zoom-out-95 data-[state=open]:vai-zoom-in-95 data-[side=bottom]:vai-slide-in-from-top-2 data-[side=left]:vai-slide-in-from-right-2 data-[side=right]:vai-slide-in-from-left-2 data-[side=top]:vai-slide-in-from-bottom-2',
      className,
    )}
    {...props}
  />
  // </PopoverPrimitive.Portal>
));
PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export { Popover, PopoverTrigger, PopoverContent, PopoverPortal };
